import Helmet from 'react-helmet';
import React from 'react';

import { getImageUrl } from '../../../helpers';
import BackgroundImage from '../components/BackgroundImage';
import styles from './download.scss';

const Download = () => (
  <>
    <Helmet>
      <title>DreamHack · Get the app</title>
    </Helmet>
    <div className={styles.download}>
      <div className={styles.information}>
        <h1>Get the DreamHack App</h1>
        <h2>
          Create your personal schedule. Easy check-in.
          {' '}
          Watch esports. Play games. Never get lost again.
        </h2>
        <div className={styles.stores}>
          <a
            className={styles.badge}
            href="https://itunes.apple.com/us/app/dreamhack/id1390494035?mt=8"
            style={{ backgroundImage: `url(${getImageUrl('84c7d111-0bd1-4b5b-935b-5bd7fa6b8840')})` }}
          >
            {' '}
          </a>
          <a
            className={styles.badge}
            href="https://play.google.com/store/apps/details?id=com.dreamhack.app&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            style={{ backgroundImage: `url(${getImageUrl('baa3e475-4f5c-44e0-b8f7-17e8c2585960')})` }}
          >
            {' '}
          </a>
        </div>
      </div>
      <BackgroundImage
        src={getImageUrl('a9a29c80-9cf6-478d-a7b7-e8b4a9718f88')}
        className={styles.screenshot}
      />
    </div>
  </>
);

export default Download;
